export const FiltersModalTrigger = ({ onClick, placeholder = "filters..." }) => {
    return (
        <div className="rounded bg-white border">
            <button
                type="button"
                className="btn btn-none p-0 m-0 d-flex align-items-center justify-content-between text-muted font-weight-light pl-2"
                style={ { height: "34px", width: "150px" } }
                onClick={ onClick }
            >
                <span className="fs--1 font-weight-bolder">{ placeholder }</span>
                <span className="d-flex align-items-center h-100 pl-2 pr-2" style={ { borderLeft: "1px solid #d8e2ef" } }>
                    <i className="fas fa-chevron-down"></i>
                </span>
            </button>
        </div>
    )
}